import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLang } from "@/i18n";

const TXT = {
  fr: { text: "Nous utilisons uniquement des cookies techniques nécessaires au bon fonctionnement du site (langue, session). Aucun traçage publicitaire.", accept: "J'accepte", refuse: "Refuser", learn: "En savoir plus" },
  nl: { text: "We gebruiken enkel technische cookies die nodig zijn voor de goede werking van de site (taal, sessie). Geen reclametracking.", accept: "Ik aanvaard", refuse: "Weigeren", learn: "Meer info" },
  en: { text: "We only use technical cookies necessary for the site to work (language, session). No advertising tracking.", accept: "I accept", refuse: "Refuse", learn: "Learn more" },
};

export const CookieBanner = () => {
  const { lang } = useLang();
  const [show, setShow] = useState(false);
  const t = TXT[lang] || TXT.fr;

  useEffect(() => {
    if (!localStorage.getItem("ilease_cookie")) setShow(true);
  }, []);

  const choose = (choice) => {
    localStorage.setItem("ilease_cookie", choice);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 120, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 120, opacity: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 28 }}
          className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60] glass rounded-2xl p-5 border border-white/10 accent-glow"
          data-testid="cookie-banner">
          <div className="flex items-start gap-3">
            <div className="w-9 h-9 shrink-0 rounded-xl bg-accent/15 flex items-center justify-center">
              <Cookie className="w-5 h-5 text-accent" strokeWidth={1.5} />
            </div>
            <div className="flex-1">
              <p className="text-xs text-muted-foreground leading-relaxed">
                {t.text}{" "}
                <Link to="/mentions-legales" className="text-accent hover:underline" data-testid="cookie-learn">{t.learn}</Link>
              </p>
              <div className="mt-3 flex gap-2">
                <button onClick={() => choose("accepted")} data-testid="cookie-accept"
                  className="flex-1 rounded-full bg-accent text-white text-sm font-medium py-2 hover:bg-accent/90 transition-colors">{t.accept}</button>
                <button onClick={() => choose("refused")} data-testid="cookie-refuse"
                  className="rounded-full border border-white/15 text-muted-foreground text-sm px-4 py-2 hover:text-white transition-colors">{t.refuse}</button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
